import {getDetail} from "../../api/pay"
export default {
    data() {
        return {
          formInline: {
            coin: '',
            chain: '',
            amount: '',
            id:"",
            userAddress:"",
            fromAddres:"",
            balance:"",
            appliedTime:"",
            refund:"",
            refundTime:"",
            refundTxid:"",
            message:"",
            email:"",
            appliedAddress:"",

           
          },
          params:{
            id:""
          }
        

        }
    },
    mounted() {
        
        this.params.id = this.$route.query.id
        this.fetchWithdrawalDetails(this.params)

    },
    methods: {
      //请求提交充值
      async fetchWithdrawalDetails(params){
        // this.RechargeLoading=true
        const {data} = await getDetail(params)
        console.log(data,"及哦飞机佛");
        this.formInline =data.data
        this.formInline.appliedTime = `${this.formInline.appliedTime.split(`T`)[0]} ${this.formInline.appliedTime.split(`T`)[1].split(`.`)[0]}` 
        this.formInline.refundTime = `${this.formInline.refundTime.split(`T`)[0]} ${this.formInline.refundTime.split(`T`)[1].split(`.`)[0]}` 

        // this.RechargeLoading=false
      },
   

    }
}